import axios from '@/libs/api.request'
const report = {
    // 汇总 
    getReportSummary: (data) => {
        return axios.get({
            url: '/Report/summary?' + axios.parseParams(data),
        })
    },
    // 明细 
    getReportDetail: (data) => {
      return axios.get({
          url: '/Report/detail?' + axios.parseParams(data),
      })
  }
}
export default report


// WEBPACK FOOTER //
// ./src/api/api-report.js